'use client'

import { User, Menu, PanelLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { NotificationsDropdown, DownloadsDropdown } from '@/components/partials/layout'
import { LanguageSwitcher, ThemeModeSwitcher } from '@/components/partials'
import { AppUserDropdown } from '@/components/partials/layout'
import { MetaData } from '@/types/meta'

type PropsType = {
  onMenuClick: () => void
  onToggleSidebar: () => void
  isMobile: boolean
  sidebarCollapsed: boolean
  metaData: MetaData
  locale: string
}

const AppHeader = ({ onMenuClick, onToggleSidebar, isMobile, metaData, locale }: PropsType) => {
  return (
    <header className="border-sidebar-border bg-background/20 supports-backdrop-filter:bg-background/10 sticky top-0 z-1 flex h-16 shrink-0 items-center gap-2 border-b px-4 backdrop-blur-xl">
      {isMobile ? (
        <Button variant="ghost" size="icon" onClick={onMenuClick} className="h-7 w-7">
          <Menu className="h-4 w-4" />
          <span className="sr-only">Toggle Menu</span>
        </Button>
      ) : (
        <Button variant="ghost" size="icon" onClick={onToggleSidebar} className="h-7 w-7">
          <PanelLeft className="h-4 w-4" />
          <span className="sr-only">Toggle Sidebar</span>
        </Button>
      )}

      <div className="ml-auto flex items-center gap-2">
        <ThemeModeSwitcher />

        <LanguageSwitcher locales={metaData.locales} locale={locale} />

        <DownloadsDropdown />

        <NotificationsDropdown />

        <AppUserDropdown>
          <Button variant="outline" size="icon">
            <User className="h-4 w-4" />
          </Button>
        </AppUserDropdown>
      </div>
    </header>
  )
}

export default AppHeader
